import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  // skills: [],
  skillListings: [],
  // currentSkillListing: null,
  searchedDiscipline: [],
  error: {},
};

const skillListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CANDIDATE_SKILLLISTING:
      return{
        ...state,
        loading: true,
      }
    case types.GET_CANDIDATE_SKILLLISTING_SUCCESS:
      return{
        ...state,
        loading: false,
        skillListings: action.payload,
        error: false,
      }
    case types.GET_CANDIDATE_SKILLLISTING_FAILURE:
      return{
        ...state,
        loading: false,
        skillListings: [],
        error: true,
      }
    // case types.FETCH_SKILLS_INIT:
    //   return {
    //     ...state,
    //     loading: true,
    //   };

    // case types.FETCH_SKILLS_SUCCESS:
    //   const skills = action.payload;
    //   return {
    //     ...state,
    //     loading: false,
    //     skills,
    //     error: {},
    //   };

    // case types.CREATE_SKILL_LISTING_INIT:
    //   return {
    //     ...state,
    //     loading: true,
    //   };

    // case types.UPDATE_SKILL_LISTING_INIT:
    //   return {
    //     ...state,
    //     loading: true,
    //   };

    // case types.UPDATE_SKILL_LISTING_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     // skillListings: [action.payload],
    //     currentSkillListing: action.payload,
    //     error: {},
    //   };

    // case types.FETCH_USER_SKILLISTING_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     skillListings: action.payload,
    //     error: {},
    //   };

    case types.FETCH_SEARCH_DISCIPLINE_INIT:
      return {
        ...state,
        disciplineLoader: true,
        searchedDiscipline:[]
      };

    case types.FETCH_SEARCH_DISCIPLINE_SUCCESS:
      // // 
      return {
        ...state,
        loading: false,
        disciplineLoader: false,
        searchedDiscipline: action.payload,
        error: {},
      };

    case types.SKILLLISTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        disciplineLoader:false,
        searchedDiscipline:[]
      };

    default:
      return state;
  }
};

export default skillListingReducer;
